import { type Ref, watch } from 'vue';
import { getDestinationResortIds } from '@/entities/searchCriteria';
import type { SearchFiltersSource } from './types';
import type { SerpFilters } from './useSerpFilters';

const RESORT_IDS_SEPARATOR = '.';

export function useSerpFiltersDraft(
  serpFilters: Pick<SerpFilters, 'syncDraft' | 'syncResortsDraft'>,
  criteria: Ref<SearchFiltersSource>,
  isOpen: Ref<boolean>,
): void {
  watch(
    isOpen,
    (open) => {
      if (open) serpFilters.syncDraft();
    },
    { immediate: true, flush: 'sync' },
  );

  watch(
    () => getDestinationResortIds(criteria.value.destination).join(RESORT_IDS_SEPARATOR),
    () => {
      if (isOpen.value) serpFilters.syncResortsDraft();
    },
  );
}
